import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import throttle from 'lodash/throttle';
import { useAction } from 'hooks';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Loupe from 'svg/loupe.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import { SEARCH_PATIENTS_FORM } from '../../constants';
import messages from '../../messages';
import styles from './SearchPatients.pcss';
const SearchPatients = ({ forId, formName, clearOnBlur })=>{
    const id = `${forId}-search`;
    const searchFormName = formName || SEARCH_PATIENTS_FORM;
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const formValues = useSelector(App.selectors.formSelector(searchFormName));
    const setSearch = useAction(actions.setPatientsSearch, forId);
    const setFormValue = useAction(App.actions.setFormValue, searchFormName);
    const clearForm = useAction(App.actions.clearForm, searchFormName);
    useStyles(styles);
    const onSetSearch = throttle(setSearch, 300);
    const clearSearch = ()=>{
        setSearch('');
    };
    const onChange = (input)=>{
        setFormValue(input);
        onSetSearch(input.value.toLowerCase());
    };
    const onFocus = (input)=>{
        onSetSearch(input.value.toLowerCase());
    };
    const onBlur = ()=>{
        if (clearOnBlur) {
            clearForm();
        }
        setTimeout(clearSearch, 100);
    };
    useEffect(()=>{
        clearSearch();
        clearForm();
    }, [
        activeClinicMembership
    ]);
    return /*#__PURE__*/ _jsxs(Form, {
        className: styles.searchPatients,
        children: [
            /*#__PURE__*/ _jsx(FormGroup, {
                id: id,
                className: cn(styles.searchPatients__formGroup, {
                    [styles[`searchPatients__formGroup--${forId}`]]: styles[`searchPatients__formGroup--${forId}`]
                }),
                formValues: formValues,
                children: /*#__PURE__*/ _jsx(Input, {
                    placeholder: messages.placeholders.searchPatients,
                    className: styles.searchPatients__formGroup__input,
                    attributes: {
                        autoComplete: 'off'
                    },
                    onChange: onChange,
                    onFocus: onFocus,
                    onBlur: onBlur
                })
            }),
            /*#__PURE__*/ _jsx(Loupe, {
                className: styles.searchPatients__icon
            })
        ]
    });
};
export default SearchPatients;
